import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import GrouperBodyEmbedded from 'components/grouper-common/GrouperBodyEmbedded.vue';
  import GrouperBodyFullscreen from 'components/grouper-common/GrouperBodyFullscreen.vue';
  import {GrouperLayoutMode} from 'src/services/IodineGrouperService';
  import { useLayoutStore } from 'stores/layout-store';

export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBody',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row items-start full-width grouper-body", _unref(useLayoutStore)().isAprExpanded ? 'with-apr' : ''])
  }, [
    (_unref(useLayoutStore)().layoutMode === _unref(GrouperLayoutMode).consolidated)
      ? (_openBlock(), _createBlock(GrouperBodyEmbedded, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(useLayoutStore)().layoutMode === _unref(GrouperLayoutMode).fullScreen)
      ? (_openBlock(), _createBlock(GrouperBodyFullscreen, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})